import state from './grouppermission.state'
import mutations from './grouppermission.mutations'
import actions from './grouppermission.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
